import {QRCodeSVG} from 'qrcode.react';
import {view} from '@sail/ui';
import {WalletConnectIcon} from 'src/v2/components/wallet/WalletConnectIcon';

const createWhiteImageBase64 = (size: number): string => {
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return '';
  }
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL('image/png');
};

const QR_CODE_SIZE = 266;
const EXCAVATE_AREA_SIZE = 64;

const whiteImageBase64 = createWhiteImageBase64(EXCAVATE_AREA_SIZE);

interface QrCodeProps {
  qrCodeUri: string;
  iconUrl?: string;
  name?: string;
  size?: number;
}

export const QrCode = ({
  qrCodeUri,
  iconUrl,
  name,
  size = QR_CODE_SIZE,
}: QrCodeProps) => {
  const showIcon = iconUrl && name;

  return (
    <view.div css={{stack: 'z'}}>
      <view.div>
        <QRCodeSVG
          value={qrCodeUri}
          size={size}
          level="H"
          marginSize={0}
          imageSettings={
            showIcon
              ? {
                  // Create a white image to be used as the background of the icon.
                  // We use this just so we can "excavate" pixels in the center to create clean, non-overlapping edges.
                  src: whiteImageBase64,
                  height: EXCAVATE_AREA_SIZE,
                  width: EXCAVATE_AREA_SIZE,
                  excavate: true,
                }
              : undefined
          }
        />
      </view.div>
      {showIcon ? (
        <view.div
          css={{
            alignSelfX: 'center',
            alignSelfY: 'center',
          }}
        >
          <WalletConnectIcon
            iconUrl={iconUrl}
            name={name}
            width="44px"
            height="44px"
            borderRadius="large"
          />
        </view.div>
      ) : null}
    </view.div>
  );
};
